import { io } from "socket.io-client";

const apiUrl = import.meta.env.VITE_API_BASE_URL;

function generateAnonName() {
  const name = "anon" + Math.floor(Math.random() * 1000000);
  localStorage.setItem('userName', name);
  return name;
}

function getOrCreateUserName() {
  let name = localStorage.getItem('userName');
  if (!name || !name.startsWith('anon')) {
    return generateAnonName();
  }
  if (name.length > 20) {
    name = name.substring(0, 20);
    localStorage.setItem('userName', name);
  }
  return name;
}

function getOrCreateDeviceId() {
  let deviceId = localStorage.getItem('deviceId');
  if (!deviceId) {
    const generateRandomHex = (length) => {
      return Array.from({ length }, () => 
        Math.floor(Math.random() * 16).toString(16)
      ).join('');
    };
    deviceId = `${generateRandomHex(8)}`;
    localStorage.setItem('deviceId', deviceId);
  }
  return deviceId;
}

let userName = getOrCreateUserName();
const deviceId = getOrCreateDeviceId();

export const socket = io(apiUrl, {
  query: { userName, deviceId }
});

export function resetToAnonName() {
  userName = generateAnonName();
  return userName;
}

export { userName, deviceId };
